import React from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from '../../images/slider/5.png'

const settings = {
    dots: false,
    arrows: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2500,
    fade: true
};

const Hero = () => {
    return (
        <section className="hero hero-slider-wrapper hero-style-1">
            <div className="hero-slider">
                <Slider {...settings}>
                    <div className="slide">
                        <div className="container">
                            <div className="row">
                                <div className="col col-lg-6 col-md-8 col-sm-12 slide-caption">
                                    <div className="slide-title-sub">
                                        <h5>Endüstriyel Soğuk Zincirde Güvenilir Çözüm Ortağınız</h5>
                                    </div>
                                    <div className="slide-title">
                                        <h2>İşletmenize Özel Soğuk Hava Deposu Sistemleri</h2>
                                    </div>
                                    <div className="slide-subtitle">
                                        <p>Modern mühendislik yaklaşımı, kaliteli malzeme seçimi ve yüksek enerji verimliliği standartları ile Kuyaş, gıda, lojistik ve sanayi sektörleri için uzun ömürlü ve güvenilir soğuk hava depoları üretmektedir.</p>
                                    </div>
                                    <div className="btns">
                                        <Link to="/about" className="theme-btn">Teklif Alın</Link>
                                    </div>
                                    <div className="slider-pic">
                                        <img src={hero1} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        </section>
    )
}

export default Hero;